// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"sortDropdown_dropdown_2Hh_zWI","dropdownTrigger":"sortDropdown_dropdownTrigger_3EP6fiP","dropdownIcon":"sortDropdown_dropdownIcon_3obbiB7"};